import { parse, ParsedQuery } from 'query-string';
import { GroupFieldsMeta } from 'components/pages/filter-transformer';
import { FilterGroupType } from 'components/pages/types';
import { Transformer as SearchTransformer } from 'hooks/use-search';
import { ResourceManagementSearchParams } from '../types';
import {
  from_resource_management_filter_query,
  ParsedResourceManagementFilterQuery,
  to_parsed_resource_management_filter_query,
  to_resource_management_filter_query,
} from './filter-transformer';

export type ParsedResourceManagementSearchQuery =
  ParsedResourceManagementFilterQuery & {
    viewId: string | null;
  };
export const to_parsed_resource_management_search_query = (
  query: ParsedQuery,
): Partial<ParsedResourceManagementSearchQuery> => ({
  ...to_parsed_resource_management_filter_query(query),
  ...{
    viewId:
      query.viewId == null
        ? null
        : typeof query.viewId === 'string'
        ? query.viewId
        : query.viewId[0],
  },
});
export const from_resource_management_search_query =
  (lookup: GroupFieldsMeta, defaultGroup: FilterGroupType) =>
  (
    query: Partial<ParsedResourceManagementSearchQuery>,
  ): ResourceManagementSearchParams => ({
    ...from_resource_management_filter_query(lookup, defaultGroup)(query),
    viewId:
      query.viewId == null || query.viewId === '-1'
        ? undefined
        : parseInt(query.viewId, 10),
  });
export const from_search =
  (lookup: GroupFieldsMeta, defaultGroup: FilterGroupType) =>
  (query: string): ResourceManagementSearchParams =>
    from_resource_management_search_query(
      lookup,
      defaultGroup,
    )(to_parsed_resource_management_search_query(parse(query)));

const to_resource_management_search_query = ({
  filter,
  availabilityFilter,
  viewId,
}: ResourceManagementSearchParams): ParsedResourceManagementSearchQuery => ({
  ...to_resource_management_filter_query({ filter, availabilityFilter }),
  ...{ viewId: viewId == null || viewId === -1 ? null : viewId.toString() },
});

export const getResourceManagementSearchTransformer = (
  lookup: GroupFieldsMeta,
  defaultGroup: FilterGroupType,
): SearchTransformer<ResourceManagementSearchParams> => ({
  from: (parsed) =>
    from_resource_management_search_query(
      lookup,
      defaultGroup,
    )(to_parsed_resource_management_search_query(parsed)),
  to: to_resource_management_search_query,
});
